import { WEB_COMPONENT_BETA_PROGRAM_SECTION } from '../../../../../webcomponents.constants';
import { BetaProgramSection } from './component/BetaProgramSection';

export { BetaProgramSection };
window.customElements.define(WEB_COMPONENT_BETA_PROGRAM_SECTION, BetaProgramSection);
